import { render, staticRenderFns } from "./LoanEntries.vue?vue&type=template&id=51b01139"
import script from "./LoanEntries.vue?vue&type=script&lang=js"
export * from "./LoanEntries.vue?vue&type=script&lang=js"
import style0 from "./LoanEntries.vue?vue&type=style&index=0&id=51b01139&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports